import * as React from "react";
import GroupCard from "./GroupCard";
import { GroupServiceGetManyResponse } from "../../services/api";

export default function GroupsList({ groups, onStatusChange }: { groups: GroupServiceGetManyResponse[], onStatusChange: () => void }) {
  return (
    <>
      <div className="grid gap-4">
        {groups.map((group, groupIndex) => (
          <GroupCard group={group} key={`group_${groupIndex}`} onCompletionStatusChange={onStatusChange} />
        ))}
      </div>
    </>
  );
}